<template>
  <div class="main">
    <div class="header">
      <h1 class="z_title">佛 吉 亚 （ 常 熟 ） 汽 车 部 件 系 统 有 限 公 司</h1>
      <h1 class="e_title">Faurecia (Changshu) Automotive Parts Systems Co., Ltd</h1>
    </div>
    <div class="zw"></div>
    <div class="table_warp">
      <div class="title_table">施工进行表</div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="orderNo" label="施工单号"></el-table-column>
        <el-table-column prop="createTime" label="申请时间"></el-table-column>
        <el-table-column prop="workName" label="工作名称"></el-table-column>
        <el-table-column prop="contractorName" label="承包商全称"></el-table-column>
        <el-table-column prop="contractorUser" label="承包商负责人" width="100"></el-table-column>
        <el-table-column prop="contractorPhone" label="负责人手机号"></el-table-column>
        <el-table-column prop="refDepartName" label="接口部门" width="90"></el-table-column>
        <el-table-column prop="refDepartUserName" label="接口人员" width="90"></el-table-column>
        <el-table-column prop="date" label="施工单有效期" width="180">
          <template #default="scope">
            <p>起{{ scope.row.licenseStartTime }}{{ scope.row.licenseStartHour }}</p>
            <p>至{{ scope.row.licenseEndTime }}{{ scope.row.licenseEndHour }}</p>

          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220">
          <template #default="scope">
            <el-button link type="primary" size="small" @click="handleDetails(scope.row)">施工详情</el-button>
            <el-button link type="primary" size="small" @click="handleFireDetails(scope.row)">动火许可</el-button>
            <el-button link type="primary" size="small" @click="handleHeightDetails(scope.row)">高处许可</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <BusinessFirePrint ref="BusinessFirePrintRef" />
    <BusinessHeightPrint ref="BusinessHeightPrintRef" />
    <Details ref="DetailsRef" />

  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import { ref, onMounted } from 'vue';
import BusinessFirePrint from '@/components/BusinessFirePrint.vue';
import BusinessHeightPrint from '@/components/BusinessHeightPrint.vue';
import Details from '@/components/Details.vue';
import { areaInfoOrderList } from '@/api/index';
const areaId = ref('')

// 数据
const tableData = ref([]);

// 子组件引用
const BusinessFirePrintRef = ref(null);
const BusinessHeightPrintRef = ref(null);
const DetailsRef = ref(null)


// 方法
const handleDetails = (row) => {
  console.log('施工详情:', row);
  DetailsRef.value.open(row);
};

const handleFireDetails = (row) => {
  console.log('动火许可:', row);
  if (row.hotWordContext) {
    BusinessFirePrintRef.value.open(row.hotWordContext);
  } else {
    ElMessage({
      message: '未查询到动火许可',
      type: 'info',
    })
    return;
  }

};

const handleHeightDetails = (row) => {
  console.log('高处许可:', row);
  if (row.hotWordContext) {
    BusinessHeightPrintRef.value.open(row.higherThanContext);
  } else {
    ElMessage({
      message: '未查询到高处许可',
      type: 'info',
    })
    return;
  }
}

// 生命周期钩子
onMounted(() => {
  // 假设从路由中获取数据
  const areaIdVal = window.location.search.split('=')[1] || undefined;
  areaId.value = areaIdVal;
  loadData();
});

const loadData = async () => {
  const res = await areaInfoOrderList({ id: areaId.value });
  tableData.value = res.data[0].lbyBusinessMaintenanceOrderList;
}


</script>

<style scoped>
.z_title {
  font-size: 32px;
  margin-bottom: 10px;
}

.e_title {
  font-size: 28px;
  margin-top: 0;
}

.header {
  color: #0026CD;
}

.zw {
  width: 100%;
  height: 10px;
  background-color: #f3f3f3;
}

.table_warp {
  padding: 20px 35px;
}

.title_table {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  color: #000000;
  padding-bottom: 20px;
}
</style>